// extracted by mini-css-extract-plugin
export default {"modalLocal":"styles_modalLocal__Q0Dp7","table":"styles_table__lVd4A","custom":"styles_custom__4VvaL","inputsRow":"styles_inputsRow__f7Xi5"};